export default __webpack_public_path__ + "static/media/error-outline-icon.7e1c9e75.svg";